<template>
    <div class="my">
        <div class="header" :style="{background:'url(' + pageData.background_img + ')'}">
            <div class="btns">
                <div @click="showPop(1)">规格</div>
                <div @click="showPop(2)">奖品</div>
            </div>
            <div class="news">
                <img :src="ranking.user.wx_avatar" alt="">
                <div class="news-cont">
                    <div>
                        <span>平均用时</span>
                        <span class="value">{{ranking.user.used_at}}</span>
                    </div>
                    <div>
                        <span>正确率</span>
                        <span class="value">{{ranking.user.bingo}}</span>
                    </div>
                </div>
                <div class="btn">去答题</div>
            </div>
        </div>
        <div class="content">
            <div class="switch-tab" @click="switchType">
                <div :class="{active:type == 1}" data-type="1">答题榜</div>
                <div :class="{active:type == 2}" data-type="2">我的奖品</div>
            </div>
            <div class="list" :class="{prize:type == 2}">
                <template v-if="type == 1">
                    <div class="head">
                        <div class="item">
                            <span class="tit">用户名称</span>
                            <span class="time">平均用时</span>
                            <span class="chance">正确率</span>
                        </div>
                    </div>
                    <div class="item" v-for="(item,index) in ranking.ranking" :key="'user' + index">
                        <img :src="item.wx_avatar" alt="">
                        <span class="tit">{{item.nickname}}</span>
                        <span class="time">{{item.used_at}}</span>
                        <span class="chance">{{item.bingo}}</span>
                    </div>
                </template>
                <template v-else>
                    <div class="prize-item" v-for="(item,index) in myPrize" :key="'prize' + index">
                        <img :src="item.img" alt="">
                        <span class="tit">{{item.title}}</span>
                        <span class="btn" @click="receiveAward(item)">去兑奖</span>
                    </div>
                </template>
            </div>
        </div>
        <div class="share">
            <div class="btn">
                <img src="../assets/prize-share.png" alt="">
                <span>分享给小伙伴们</span>
            </div>
            <div class="bkg"></div>
        </div>

        <tips :showTips="isShowPop" :title="title" :content="content" @closeTips="showPop"/>
    </div>
</template>

<script>
import tips from '@/components/common/answer-tips'
import Apis from '../config/apis'
import _ from '../config/util'

export default {
    components:{
        tips
    },
    data () {
        return {
            type:1,
            imgs:[
                'https://img2.baidu.com/it/u=3666548066,2508071679&fm=26&fmt=auto',
                'https://img2.baidu.com/it/u=622902245,3661794572&fm=26&fmt=auto',
                'https://img0.baidu.com/it/u=3436810468,4123553368&fm=26&fmt=auto',
                'https://img2.baidu.com/it/u=3642339878,2140733972&fm=26&fmt=auto',
                'https://img1.baidu.com/it/u=1719063513,2559625643&fm=26&fmt=auto',
                'https://img0.baidu.com/it/u=3436810468,4123553368&fm=26&fmt=auto',
                'https://img2.baidu.com/it/u=3642339878,2140733972&fm=26&fmt=auto',
                'https://img2.baidu.com/it/u=3666548066,2508071679&fm=26&fmt=auto',
                'https://img0.baidu.com/it/u=3436810468,4123553368&fm=26&fmt=auto',
                'https://img2.baidu.com/it/u=622902245,3661794572&fm=26&fmt=auto',
            ],
            isShowPop:false,
            title:'',
            content:'',
            uid:'', // 用户id
            id:'', // 活动id
            pageData:{},
            ranking:{ // 答题数据
                user:{},
                ranking:[]
            },
            myPrize:[],
            scenic:''
        }
    },
    computed:{
        isWeiXin() {
            return this.$store.state.isWeiXin
        },
    },
    mounted(){
        this.uid = this.$route.query.uid
        this.id = this.$route.query.id
        // this.scenic = this.$route.query.scenic
        this.scenic = 1

        if(this.id) this.initData()
    },
    methods:{
        switchType(e){
            this.type = e.target.dataset.type
        },
        showPop(type){
            this.isShowPop = !!type
            if(type == 1){
                this.title = '活动规则'
                this.content = this.pageData.rule
            }else if(type == 2){
                this.title = '活动奖品'
                this.content = this.pageData.introduce
            }
        },
        initData(){
            this.axios.post(Apis.question, {
                bank_id: this.id
            }).then(res => {
                this.pageData = res.data
            })

            this.axios.post(Apis.questionRanking, {
                bank_id: this.id,
                uid: this.uid
            }).then(res => {
                this.ranking = res.data
            })

            this.axios.post(Apis.questionUserGifts, {
                bank_id: this.id,
                uid: this.uid,
                limit: 999
            }).then(res => {
                this.myPrize = res.data
            })
        },
        // item.type 10活动卡-跳卡包消费卡活动卡详情 20 第三方-跳第三方小程序 30 关联电商商品-跳电商商品, 40:联系客服兑换
        receiveAward(item){
            let url = ''
            if(item.unify_gift_type == 10) {
                url = `packages/coupon/list/index?id=${item.unify_gift_fid}&type=${item.active_single_coupon}`
            } else if (item.unify_gift_type == 30) {
                url = `packages/shop/goods/detail/index?id=${item.unify_gift_fid}&stype=${1}&sval=${item.unify_gift_fid}`
            }

            if(this.isWeiXin && url){ // 小程序跳转
                window.uni.miniProgram.navigateTo({
                    url: `/${url}`
                })
            } else if (this.isWeiXin && item.type == 20){ // 跳转第三方小程序
                window.uni.miniProgram.navigateToMiniProgram({
                    appId: item.unify_gift_appid,
                    path: item.unify_gift_path, 
                })
            } else if (url){
                window.location.href = `${(this.scenic == 1 ? this.$scenicUrl : this.$baseurl) + url}`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.my{
    background: #FEEDC3;
    height: 100vh;
    overflow: auto;

    .header{
        width: 100%;
        height: 5rem;
        background: turquoise;
        position: relative;
        .btns{
            position: absolute;
            right: 0;
            top: 1.4rem;
            div{
                width: 1.06rem;
                height: 0.5rem;
                line-height: 0.5rem;
                background: #000000;
                opacity: 0.2;
                border-radius: 0.25rem 0px 0px 0.25rem;
                font-size: 0.28rem;
                color: #FFFFFF;
                margin-bottom: 0.48rem;
                text-align: center;
            }
        }
        .news{
            font-size: 0.28rem;
            margin: 0 0.3rem;
            background: #FFFFFF;
            height: 1.5rem;
            border-radius: 0.2rem;
            padding: 0.25rem 0.35rem;
            display: flex;
            align-items: center;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0.16rem;
            &>img{
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                border: 0.05rem solid #FBF4C0;
            }
            .news-cont{
                display: flex;
                justify-content: space-evenly;
                flex: 1;
                &>div{
                    display: flex;
                    flex-direction: column;
                    span{
                        font-weight: bold;
                        color: #333333;
                        &.value{
                            color: #FFB505;
                            margin-top: 0.14rem;
                        }
                    }
                }
            }
            .btn{
                width: 1.5rem;
                height: 0.66rem;
                line-height: 0.66rem;
                background: linear-gradient(0deg, #9E37F6 0%, #C579FB 100%);
                box-shadow: 0px 0.06rem 0px 0px #8B27E1;
                border-radius: 0.33rem;
                text-align: center;
                color: #FFFFFF;
            }
        }
    }
    .content{
        margin: 0.12rem 0.3rem;
        min-height: calc(100vh - 5rem - 2.33rem);
        .switch-tab{
            height: 0.88rem;
            line-height: 0.88rem;
            display: flex;
            div{
                flex: 1;
                border-radius: 0.2rem 0.2rem 0px 0px;
                font-size: 0.32rem;
                font-weight: bold;
                background: #FFB505;
                color: #FFFFFF;
                &.active{
                    background: #FFFFFF;
                    color: #FFB505;
                }
            }
        }
        .list{
            // height: 7.86rem;
            overflow: auto;
            background: #FFFFFF;
            border-radius: 0px 0px 0.2rem 0.2rem;
            .head{
                padding-top: 0.3rem;
                background: #FFFFFF;
                position: sticky;
                top: 0;
                z-index: 2;
                padding-bottom: 0.3rem;
                .item{
                    height: 0.66rem;
                    background: #F4F4F4;
                    border-radius: 0.1rem;
                    margin-bottom: 0;
                    span{
                        font-size: 0.24rem;
                        font-weight: 500;
                        color: #999999;
                    }
                    .tit{
                        padding-left: 1.17rem;
                    }
                }
            }
            .item{
                position: relative;
                margin: 0 0.15rem;
                display: flex;
                align-items: center;
                margin-bottom: 0.3rem;
                img{
                    width: 0.79rem;
                    height: 0.79rem;
                    border-radius: 50%;
                    margin-left: 0.11rem;
                    margin-right: 0.27rem;
                }
                .tit{
                    font-size: 0.28rem;
                    font-weight: 500;
                    color: #333333;
                    flex: 1;
                    text-align: left;
                    width: 100px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .time, .chance{
                    font-size: 0.28rem;
                    font-weight: bold;
                    color: #FFB505;
                    width: 1.6rem;
                    text-align: center;
                }
                .chance{
                    width: 1.4rem;
                }
            }
        }
        .prize{
            // padding: 0.3rem;
            columns: 2;
            column-gap: 0px;
            padding-bottom: 0.3rem;
            .prize-item{
                width: 3rem;
                display: flex;
                flex-direction: column;
                padding: 0.22rem;
                float: left;
                // justify-content: center;
                margin: 0.3rem 0 0 0.3rem;
                break-inside: avoid;
                img{
                    width: 2.56rem;
                    margin-bottom: 0.22rem;
                }
                .tit{
                    font-size: 0.28rem;
                    font-weight: 500;
                    color: #333333;
                    text-align: left;
                }
                .btn{
                    width: 1.72rem;
                    height: 0.5rem;
                    line-height: 0.5rem;
                    background: linear-gradient(180deg, #FCD035 0%, #FFB505 100%);
                    box-shadow: 0px 0.06rem 0px 0px #EEA127;
                    border-radius: 0.25rem;
                    font-size: 0.24rem;
                    font-weight: 500;
                    color: #FFFFFF;
                    text-align: center;
                    margin: 0.2rem auto 0;
                }
            }
        }
    }
    .share{
        position: relative;
        padding: 0.6rem 0;
        .btn{
            width: 3.6rem;
            height: 0.9rem;
            background: linear-gradient(0deg, #9E37F6 0%, #C579FB 100%);
            box-shadow: 0px 0.06rem 0px 0px #8B27E1;
            border-radius: 0.45rem;
            font-size: 0.28rem;
            font-weight: 500;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            img{
                width: 0.28rem;
                height: 0.28rem;
                margin-right: 0.18rem;
            }
        }
        .bkg{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 1.06rem;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.19) 47%, rgba(0, 0, 0, 0) 100%);
        }
    }
}
</style>